// extracted by mini-css-extract-plugin
export var pageContainer = "styles-module--pageContainer--7OLZK";
export var artistContainer = "styles-module--artistContainer--3wMfL";
export var artistTitle = "styles-module--artistTitle--1UHro";
export var artistImage = "styles-module--artistImage--2dgNb";
export var artistPlayerContainer = "styles-module--artistPlayerContainer--3UYL5";
export var setTimeContainer = "styles-module--setTimeContainer--1bknp";
export var setTimeImage = "styles-module--setTimeImage--1rLUd";